import React from 'react';
import { hooks, unstable } from '@broadleaf/admin-components';
import { InlineEditField } from './InlineEditField';

const { useHasAccess } = hooks;
const { MetadataUtils } = unstable;
const { getEndpointByType } = MetadataUtils;

const InlineEditColumn = props => {
  const { header, row, contextParams } = props;
  const { rowId, scope, readOnly, fieldMappings, updateFields, name } = header;
  const updateEndpoint = getEndpointByType(header, 'UPDATE');
  const hasAccess = useHasAccess(scope, ['UPDATE']);
  const disabled = props.disabled || props.loading || !hasAccess;

  return (
    <div className={'inline-edit-row-action'}>
      <InlineEditField
        disabled={disabled}
        readOnly={readOnly}
        updateEndpoint={updateEndpoint}
        updateFields={updateFields}
        name={name}
        row={row}
        contextParams={contextParams}
        fieldMappings={fieldMappings}
        rowId={rowId}
      />
    </div>
  );
};

export { InlineEditColumn };
